// DS: C86
/** An animation put in place while we load the actual content */
import React from 'react';
import classnames from 'classnames';
import OutlinedDASymbol from '../OutlinedDASymbol';
import s from './LoadingIndicator.scss';
var LoadingIndicator = function (_a) {
    var _b = _a.view, view = _b === void 0 ? 'spinner' : _b, _c = _a.coverMode, coverMode = _c === void 0 ? false : _c, _d = _a.withOverlay, withOverlay = _d === void 0 ? false : _d, className = _a.className, spinnerClassName = _a.spinnerClassName;
    return (React.createElement("div", { className: classnames(s['root'], s["view-" + view], coverMode && s['cover-mode'], withOverlay && s['with-overlay'], className) }, {
        daSymbol: React.createElement(OutlinedDASymbol, null),
        daSymbolPurple: React.createElement(OutlinedDASymbol, { palette: "purple" }),
        watchSuggestions: React.createElement(OutlinedDASymbol, { palette: "green-to-purple" }),
        llama: React.createElement("div", { className: s['llama'] }),
        spinner: React.createElement("div", { className: classnames(s['spinner'], spinnerClassName) }),
    }[view]));
};
LoadingIndicator.displayName = 'LoadingIndicator';
export default LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map